import axios from "axios";
import AppSettings from "../appsettings";
const BASE_URL = `${AppSettings.API_BASE_URL}/Auth`;

const userService = {
    changePassword: async (data) => {
        const response = await axios.post(`${BASE_URL}/changePassword`, data);
        return response.data;
    },
};

export default userService;
